<template>
  <RouterLink to="/">
    <div class="logo-container">
      <BaseSvg class="company-logo" width="48px" height="48px" :src="CxLogo" />
      <div class="name" :class="sidebarStore.isShrink ? 'hidden' : ''">
        {{ userStore.userInfo?.name }} {{ userStore.userInfo?.surname }}
      </div>
    </div>
  </RouterLink>
</template>

<script setup lang="ts">
import { CxLogo } from "@/assets/icons";
import { BaseSvg } from "@/components/Base";
import { useSidebarStore, useUserStore } from "@/stores";
const userStore = useUserStore();
const sidebarStore = useSidebarStore();
</script>

<style scoped lang="scss">
.logo-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 10px;
  object-fit: contain;
  height: 60px;
  & .name {
    @include text-overflow(3);
    margin-top: 6px;
    font-weight: 500;
  }
  & .hidden {
    display: none;
  }
  & .logo-loader {
    padding: 0;
  }
}
</style>
